import { render, staticRenderFns } from "./TrSelectGameV2.vue?vue&type=template&id=99a4f930&scoped=true&"
import script from "./TrSelectGameV2.vue?vue&type=script&lang=js&"
export * from "./TrSelectGameV2.vue?vue&type=script&lang=js&"
import style0 from "./TrSelectGameV2.vue?vue&type=style&index=0&id=99a4f930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a4f930",
  null
  
)

export default component.exports